<template>
  <modal
    id="modalLancamentosContabeis"
    :exibir="exibir"
    :titulo="titulo"
    :campos="$refs"
    tamanho="xl"
    @fechar="fecharModal"
  >
    <div class="mb-4">
      <dados-documento
        :form="formulario"
        :valor="maiorSoma"
        @refs="capturarRefs"
      />
    </div>
    <div>
      <h4>{{ $t('CONTABIL.LISTA_LANCAMENTOS_VINCULADOS') }}</h4>
      <dados-documento-item
        ref="documentoItem"
        :form="formularioDocumentoItem"
        :resetarValidacao="resetarValidacao"
        @adicionarDocumentoItem="adicionarDocumentoItem"
        @cancelarEdicaoItem="limparFormularioDocumentoItem"
        :edicao="edicao"
      />
      <tabela-documento
        ref="tabelaDocumento"
        :items="formulario.itens"
        :keyAtualizatabela="keyAtualizatabela"
        @removerDocumentoItem="removerDocumentoItem"
        @editarDocumentoItem="editarItemLancamento"
      />
      <b-row>
        <b-col
          ><b
            ><h5>Total Crédito: {{ formatarValor(creditoTotal) }}</h5></b
          ></b-col
        >
        <b-col
          ><b
            ><h5>Total Débito: {{ formatarValor(debitoTotal) }}</h5></b
          ></b-col
        >
      </b-row>
    </div>
    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button variant="primary" @click="salvar">
          {{ $t('GERAL.SALVAR') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>

<script>
// Helpers
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import confirmarDiferencaDebitoCredito from '../../confirmarDiferencaDebitoCredito';
// Services
import LancamentoContabilService from '@/common/services/lancamento-contabil/lancamento-contabil.service.js';

// Components
import Modal from '@/components/modal/Modal.vue';
import DadosDocumento from './Dados';
import TabelaDocumento from './Tabela';
import DadosDocumentoItem from './DadosDocumentoItem';

export default {
  components: {
    Modal,
    DadosDocumento,
    TabelaDocumento,
    DadosDocumentoItem,
  },
  computed: {
    titulo() {
      return !this.formulario.id
        ? this.$t('GERAL.CADASTRAR')
        : this.$t('GERAL.EDITAR');
    },
    maiorSoma() {
      let creditoTotal = 0;
      let debitoTotal = 0;

      this.formulario.itens.forEach((movimento) => {
        if (movimento.tipoMovimentoDescricao === 'Crédito') {
          creditoTotal += movimento.valor;
        } else if (movimento.tipoMovimentoDescricao === 'Débito') {
          debitoTotal += movimento.valor;
        }
      });

      return Math.max(creditoTotal, debitoTotal);
    },
    creditoTotal() {
      return this.formulario.itens.reduce((total, item) => {
        if (item.tipoMovimentoDescricao === 'Crédito') {
          return total + item.valor;
        }
        return total;
      }, 0);
    },
    debitoTotal() {
      return this.formulario.itens.reduce((total, item) => {
        if (item.tipoMovimentoDescricao === 'Débito') {
          return total + item.valor;
        }
        return total;
      }, 0);
    },
  },

  data() {
    return {
      exibir: false,
      keyAtualizatabela: 1,
      resetarValidacao: false,
      items: [{}],
      formulario: {
        itens: [],
      },
      formularioDocumentoItem: {},
      refs: [],
      edicao: false,
    };
  },
  methods: {
    formatarValor(valor) {
      return valor ? helpers.formatacaoMoedaBRL(valor) : '';
    },

    abrirModal({ item }) {
      if (!item?.id) {
        this.exibir = true;
        this.avisarLancamentosDesbalanceados();
        return;
      }

      this.$store.dispatch(START_LOADING);
      LancamentoContabilService.carregarInformacoesPorId(item.id)
        .then((res) => {
          this.formulario = res;
          this.exibir = true;
        })
        .finally(() => this.$store.dispatch(STOP_LOADING));
    },
    // Só avisa: novos lançamentos continuam liberados; quem bloqueia é o fechamento do período.
    avisarLancamentosDesbalanceados() {
      // Só a quantidade importa: os documentos ficam no filtro "Somente desbalanceados" da listagem.
      LancamentoContabilService.obterPor({
        NumeroDaPagina: 1,
        TamanhoDaPagina: 1,
        SomenteDesbalanceados: true,
      })
        .then(({ data }) => {
          const quantidade = data.paginacao.totalDeElementos;
          if (!quantidade) return;

          const chaveMensagem =
            quantidade === 1
              ? 'CONTABIL_LANCAMENTO.AVISO_LANCAMENTO_DESBALANCEADO_MENSAGEM'
              : 'CONTABIL_LANCAMENTO.AVISO_LANCAMENTOS_DESBALANCEADOS_MENSAGEM';

          mensagem.warning(
            this.$t('CONTABIL_LANCAMENTO.AVISO_LANCAMENTOS_DESBALANCEADOS'),
            this.$t(chaveMensagem, { quantidade })
          );
        })
        .catch(() => {});
    },
    buscarDocumentosContabeisItens(value) {
      if (value)
        LancamentoContabilService.obterDocumentosContabeisItensPorDocumentoContabilId(
          this.formulario.id
        )
          .then(({ data }) => {
            this.formulario.itens = data;
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
    },
    validarFormulario() {
      return helpers.validarFormulario(this.refs);
    },
    fecharModal() {
      this.formulario = {
        itens: [],
      };
      this.limparFormularioDocumentoItem();
      this.exibir = false;
    },
    capturarRefs(refs) {
      this.refs = refs;
    },
    async salvar() {
      if (!this.validarFormulario()) return;
      if (!(await confirmarDiferencaDebitoCredito(this.debitoTotal, this.creditoTotal))) return;

      const dados = {
        ...this.formulario,
        categoria: this.formulario.categoriaId,
        documentoContabeisItens: this.formulario.itens,
      };

      if (this.formulario.id) {
        return this.atualizar(dados);
      }
      this.criar(dados);
    },
    criar(dados) {
      this.$store.dispatch(START_LOADING);
      LancamentoContabilService.criar(dados)
        .then(({ data }) => {
          this.limparFormularios();
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.$emit('atualizarTabela');
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    atualizar(dados) {
      this.$store.dispatch(START_LOADING);
      LancamentoContabilService.atualizar(dados)
        .then(({ data }) => {
          this.limparFormularios();
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.$emit('atualizarTabela');
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    limparFormularios() {
      this.formulario = {
        dataDocumento: '',
        dataMovimento: '',
        documentoOrigemCodigo: '',
        tipoTituloEnum: '',
        objetoReferenciaId: '',
        itens: [],
      };
      this.formularioDocumentoItem = {};
    },
    adicionarDocumentoItem() {
      if (this.edicao) {
        return this.atualizarDocumentoItemLocal();
      }
      this.adicionarDocumentoItemLocal();
      this.limparValidacaoFormItem();
    },
    limparValidacaoFormItem() {
      setTimeout(() => {
        this.resetarValidacao = true;
      }, 50);
      this.resetarValidacao = false;
    },
    montarItemLancamento() {
      return {
        tipoMovimentoDescricao:
          this.formularioDocumentoItem.tipoMovimento.descricao,
        tipoMovimento: this.formularioDocumentoItem.tipoMovimento.id,
        valor: Number(this.formularioDocumentoItem.valor),
        planoContaId: this.formularioDocumentoItem.planoConta.id,
        descricao: this.formularioDocumentoItem.descricao,
        contaContabilCompleto: `${this.formularioDocumentoItem.planoConta.codigo} - ${this.formularioDocumentoItem.planoConta.descricao}`,
      };
    },
    adicionarDocumentoItemLocal() {
      if (!this.formulario?.itens)
        this.formulario = { ...this.formulario, itens: [] };

      this.formulario.itens.push(this.montarItemLancamento());

      setTimeout(() => {
        this.limparFormularioDocumentoItem();
      }, 100);
    },
    limparFormularioDocumentoItem() {
      this.edicao = false;
      this.formularioDocumentoItem = {
        descricao: '',
        planoConta: '',
        valor: null,
        tipoMovimento: '',
      };

      this.limparValidacaoFormItem();
    },
    atualizarDocumentoItemLocal() {
      const index = this.formularioDocumentoItem.index;
      if (index === undefined || index < 0 || index >= this.formulario.itens.length) {
        return this.limparFormularioDocumentoItem();
      }
      this.$set(this.formulario.itens, index, this.montarItemLancamento());
      this.keyAtualizatabela++;
      this.limparFormularioDocumentoItem();
    },
    editarItemLancamento(item) {
      const index = this.formulario.itens.findIndex((i) => i === item);
      if (index === -1) return;

      this.edicao = false;
      this.formularioDocumentoItem = { ...item, index };
      this.$nextTick(() => {
        this.edicao = true;
      });
    },
    removerDocumentoItem(item) {
      this.confirmarExclusao(item);
    },
    excluirDocumentoItemLocal(index) {
      const removido = this.formulario.itens.splice(index, 1);
      if (this.edicao) {
        this.limparFormularioDocumentoItem();
      }
      return removido;
    },
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('CONTABIL_LANCAMENTO.CONFIRMAR_EXCLUIR_DOCUMENTO_ITEM'),
        this.$t('CONTABIL_LANCAMENTO.CONFIRMAR_EXCLUIR_DOCUMENTO_ITEM_MENSAGEM')
      );
      if (respostaExclusao.value) {
        this.excluirDocumentoItemLocal(item.index);
      }
    },
  },
  watch: {
    maiorSoma: function (valor) {
      this.formulario.valor = valor;
    },
  },
};
</script>
